import React, { useEffect, useState } from 'react'
import { Input } from 'reactstrap'
import { FaPaperPlane } from 'react-icons/fa'
import { Wrapper, BoxIcon } from './styles'
import { InputCnpjCpf, InputTelefone, Select, toast } from '../../../Components'
import { isValidCnpj, isValidEmail, isValidTelefone, isValidFirstNameAndLastName } from '../../../helpers/util'

const initValues = { codigo: 0, normaId: 0, descricao: '', laboratorioId: 0 }
export default function BoxInput({ sendMessage, sendMessageSelect, msgIndex, tpServico, laboratorioId, URL_BASE, conversation }) {
  const [value, setValue] = useState('')
  const [selectedOption, setSelectedOption] = useState(null)
  const [options, setOptions] = useState([])

  useEffect(() => {
    async function loadOptions() {
      if (!laboratorioId || !laboratorioId.value) {
        return
      }

      try {
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(initValues),
        }

        const response = await fetch(`${URL_BASE}/Norma/GetByFilter`, requestOptions)
        const data = await response.json()
        if (response.ok && data && Array.isArray(data)) {
          const filteredOptions = data.filter((d) => d.laboratorioId === laboratorioId.value).map((d) => ({ value: d.normaId, label: d.descricao }))
          setOptions(filteredOptions)
        } else toast('Nenhuma norma encontrada para esse laboratório.', { type: 'error', position: 'top-right', autoClose: 5000 })
      } catch (error) {}
    }

    if (laboratorioId && laboratorioId.value && tpServico.value === 1) loadOptions()
  }, [laboratorioId])

  function onChange(e) {
    setValue(e.target.value)
  }

  function onChangeCat(newValue, actionMeta) {
    const { name } = actionMeta
    setSelectedOption(newValue)
    sendMessageSelect(newValue.value, options)
  }

  function handleSend() {
    if (value.trim()) {
      if ((tpServico.value === 1 && msgIndex === 6 && !isValidFirstNameAndLastName(value)) || (tpServico.value === 2 && msgIndex === 4 && !isValidFirstNameAndLastName(value))) {
        toast.error('Nome e sobrenome inválidos, favor preencher corretamente apenas com um espaçamento.')
        return
      }
      if ((tpServico.value === 1 && msgIndex === 7 && !isValidCnpj(value)) || (tpServico.value === 2 && msgIndex === 5 && !isValidCnpj(value))) {
        toast.error('CNPJ inválido, favor preencher corretamente.')
        return
      }
      if ((tpServico.value === 1 && msgIndex === 8 && !isValidTelefone(value)) || (tpServico.value == 2 && msgIndex == 6 && !isValidTelefone(value))) {
        toast.error('Telefone inválido, favor preencher corretamente.')
        return
      }

      if ((tpServico.value === 1 && msgIndex === 9 && !isValidEmail(value)) || (tpServico.value === 2 && msgIndex === 7 && !isValidEmail(value))) {
        toast.error('E-mail inválido, favor preencher corretamente.')
        return
      }
      sendMessage(value)
      setValue('')
    }
  }

  function handleKeyPress(e) {
    if (e.key === 'Enter') handleSend()
  }

  function getInputComponent() {
    switch (tpServico.value) {
      case 1:
        switch (msgIndex) {
          case 4:
            if (conversation[conversation.length - 2]?.conteudo.value === 1)
              return <Input className="inputText" type="text" placeholder="Informe os dados da norma" onChange={onChange} onKeyPress={handleKeyPress} value={value} />
            else
              return (
                <Select
                  placeholder="Selecione o serviço desejado"
                  noOptionsMessage={() => 'Nenhuma opção disponível'}
                  onChange={onChangeCat}
                  value={selectedOption}
                  isClearable
                  name="normaId"
                  className="basic-multi-select"
                  options={options}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  menuPlacement="top"
                  classNamePrefix="mySelect"
                />
              )
          case 5:
            return <Input className="inputText" type="text" placeholder="Em que posso ajudar..." onChange={onChange} onKeyPress={handleKeyPress} value={value} disabled={false} />
          case 6:
            return <Input className="inputText" type="text" placeholder="Digite seu nome..." onChange={onChange} onKeyPress={handleKeyPress} value={value} disabled={false} />
          case 7:
            return <InputCnpjCpf className="inputText" type="text" placeholder="Apenas números..." onChange={onChange} onKeyPress={handleKeyPress} value={value} disabled={false} />
          case 8:
            return <InputTelefone className="inputText" type="phone" placeholder="Digite seu número aqui..." onChange={onChange} onKeyPress={handleKeyPress} value={value} disabled={false} />
          case 9:
            return <Input className="inputText" type="email" placeholder="Digite seu e-mail aqui..." onChange={onChange} onKeyPress={handleKeyPress} value={value} name="otalemail" disabled={false} />
          default:
            return <Input className="inputText" type="text" placeholder="Responda acima..." value={value} disabled={true} />
        }
      case 2:
        switch (msgIndex) {
          case 3:
            return <Input className="inputText" type="text" placeholder="Em que posso ajudar..." onChange={onChange} onKeyPress={handleKeyPress} value={value} disabled={false} />
          case 4:
            return <Input className="inputText" type="text" placeholder="Digite seu nome..." onChange={onChange} onKeyPress={handleKeyPress} value={value} disabled={false} />
          case 5:
            return <InputCnpjCpf className="inputText" type="text" placeholder="Apenas números..." onChange={onChange} onKeyPress={handleKeyPress} value={value} disabled={false} />
          case 6:
            return <InputTelefone className="inputText" type="phone" placeholder="Digite seu número aqui..." onChange={onChange} onKeyPress={handleKeyPress} value={value} disabled={false} />
          case 7:
            return <Input className="inputText" type="email" placeholder="Digite seu e-mail aqui..." onChange={onChange} onKeyPress={handleKeyPress} value={value} disabled={false} />
          default:
            return <Input className="inputText" type="text" placeholder="Responda acima..." onChange={onChange} onKeyPress={handleKeyPress} value={value} disabled={true} />
        }
      default:
        return <Input className="inputText" type="text" placeholder="Responda acima..." onChange={onChange} onKeyPress={handleKeyPress} value={value} disabled={true} />
    }
  }

  const isSelectComponent = msgIndex === 4 && tpServico.value === 1

  return (
    <>
      <Wrapper>
        {getInputComponent()}
        {isSelectComponent ? null : value.trim() ? (
          <BoxIcon onClick={handleSend} disabled={false}>
            <FaPaperPlane color="#8E489C" size={22} />
          </BoxIcon>
        ) : (
          <BoxIcon disabled={true}>
            <FaPaperPlane color="#8E489C" size={22} />
          </BoxIcon>
        )}
      </Wrapper>
    </>
  )
}
